import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { TranslateService } from '@ngx-translate/core';
import { Container } from 'app/models/container.model';
import { User } from 'app/models/user.model';
import { ContainerService } from 'app/services/container.service';
import { ConfirmationDialogComponent } from 'app/services/user-interaction/components/confirmation-dialog/confirmation-dialog.component';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import * as L from 'leaflet';
import 'leaflet-draw';
import { cloneDeep } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { GenericMapComponent } from '../../generic-map/generic-map.component';
import { GarbageCenterFormComponent } from '../../map/garbage-center-form/garbage-center.component';
import { ContainerFormComponent } from '../container-form/container-form.component';
import { DeviceRequestService } from './../../../../../services/device-request.service';
import { PoligonService } from './../../../../../services/poligon.service';

@Component({
    selector: 'container-list',
    templateUrl: './container-list.component.html',
    styleUrls: ['./container-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class ContainerListComponent implements OnInit {


    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    selection = new SelectionModel<Container>(true, []);

    private _containerList: Array<Container> = [];
    
    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }

    public get containerList(): Array<Container> {
        return this._containerList;
    }

    private _dataSource: MatTableDataSource<Container> = undefined;
    public get dataSource(): MatTableDataSource<Container> {
        return this._dataSource;
    }

    private _displayedColumns = ['select','name','deviceId', 'neighbor', 'street','altitude', 'latitude','companyId', "setting"];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _fuseSidebarService: FuseSidebarService,
        private _dialog: MatDialog,
        private _spinner: NgxSpinnerService,
        private _toastService: ToasterService,
        private _containerService: ContainerService,
        private _poligonService: PoligonService,
        private _translateService:TranslateService,
        private _deviceRequestService: DeviceRequestService
    ) {
    }


    public async ngOnInit() {
        await this.getContainerList();
    }
    
    private async getContainerList(): Promise<Array<Container>> {
        try {
            
            this._spinner.show('loading');
            this._containerList =  (await this._containerService.getContainers(parseInt(localStorage.getItem("CompanyID"))));
            await this.updateTableDataSource();
            this._spinner.hide('loading');

        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
            return [];
        }
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<Container>(this._containerList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    public addContainer() {
        const dialog = this._dialog.open(ContainerFormComponent, {
            data: new Container(),
            disableClose: false
        });
        dialog.componentInstance.operation = "create"
        dialog.componentInstance.added.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh();
            dialog.close();
        });
    }
    public updateContainer(container) {
        const dialog = this._dialog.open(ContainerFormComponent, {
            data: cloneDeep(container),
            disableClose: false
        });
        dialog.componentInstance._changeDevice = cloneDeep(container.deviceId);
        dialog.componentInstance.operation = "update"
        dialog.componentInstance.updated.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh();
            dialog.close();
        });
    }
    public async onContainerMap(element:Container){
        const dialog = this._dialog.open(GenericMapComponent,{
        })
        dialog.componentInstance.latitude=parseFloat(element.latitude);
        dialog.componentInstance.longitude=parseFloat(element.longitude);
    }
    public updateGarbageCenter(container){
        const dialog = this._dialog.open(GarbageCenterFormComponent,
            {
                data:container,
                disableClose:false
            })
            dialog.componentInstance.operation = "update";
            dialog.componentInstance.container=cloneDeep(container);
            dialog.componentInstance.selectedCompany=cloneDeep(container.companyId);
            dialog.componentInstance.done.subscribe((model:boolean)=>{
                model ? this._toastService.toastSuccess() : this._toastService.toastFail();
                this.refresh();
                dialog.close();
            })
    }
    public async deleteContainer(container: Container) {

        try {
            const dialog = this._dialog.open(ConfirmationDialogComponent,{

            })
            dialog.componentInstance.message = "Seçilen konteynerleri silmek istediğinize emin misiniz?"
            dialog.componentInstance.confirmed.subscribe(async(x)=>{
                let poligonDetail = await this._poligonService.getByPoligonDetail(container.id);
                this._poligonService.removeRange(poligonDetail);
                this._containerService.delete(container);
                dialog.close();
            })
            dialog.componentInstance.rejected.subscribe(async (x:any) => {
                dialog.close();
            })

        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
        }finally{
            await this.refresh();
        }
        await this.refresh();
    }

    toggleSidebar(name): void {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }
    
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    public async locationControl(container: Container) {

        if (container.device.deviceLatestStatus == null) {
            this._toastService.toastFail(this._translateService.instant("THE_DEVICE_BELONGING_TO_THE_CONTAINER_WAS_NOT_FOUND"))
            return;
        }

        let containerLocation = new L.LatLng(container.latitude, container.longitude)
        let deviceLocation = new L.LatLng(container.device.deviceLatestStatus.gpS_Enlem, container.device.deviceLatestStatus.gpS_Boylam)

        let distance = containerLocation.distanceTo(deviceLocation);
        
        if (distance >= 500) {
            this._toastService.toastFail(this._translateService.instant("DEVICE_INCORRECT_LOCATION_INFORMATION")+" : " + distance + " m")
        }
        else if (distance > 50) {
            this._toastService.toastWarning(this._translateService.instant("DEVICE_AND_CONTAINER_LOCATION_INFORMATION_DO_NOT_MATCH")+" : " + distance + " m")
        }
        else {
            this._toastService.toastInfo(this._translateService.instant("DISTANCE_BETWEEN_CONTAINER_AND_DEVICE")+" : " + distance + " m")
        }
    }

    public async ContainerDailyFilling(container:Container){
        try {
            this._spinner.show('loading')
             await this._deviceRequestService.containerDailyFilling(container.deviceId);
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
            
        }
    }
    async multiDeleteClick(){
        var ids= this.selection.selected.map(x=>x.id);
        if(ids.length==0){
            this._toastService.toastWarning("Seçili öğe bulunmuyor.")
            return;
        }
        const dialog = this._dialog.open(ConfirmationDialogComponent,{

        })
        dialog.componentInstance.message = "Seçilen konteynerleri silmek istediğinize emin misiniz?"
        dialog.componentInstance.confirmed.subscribe(async(x)=>{

            await this._containerService.multiDelete(ids)
            await this.refresh();
            dialog.close();
        })
        dialog.componentInstance.rejected.subscribe(async (x:any) => {
            dialog.close();
        })
    }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource?.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */

  checkboxLabel(row?: Container): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row!) ? 'deselect' : 'select'} row ${+1}`;
  }

    async refresh() {
        await this.getContainerList();
    }
}
